export const SHOW_LOADING = 'SHOW_LOADING';

// List
export const GET_CERTIFICATE_LIST = 'GET_CERTIFICATE_LIST';
export const GET_CERTIFICATE_LIST_SUCCESS = 'GET_CERTIFICATE_LIST_SUCCESS';
export const GET_CERTIFICATE_LIST_ERROR = 'GET_CERTIFICATE_LIST_ERROR';

// Grid Columns
export const CERTIFICATE_GRID_COLUMN_INFO = 'CERTIFICATE_GRID_COLUMN_INFO';
export const CERTIFICATE_GRID_COLUMN_INFO_SUCCESS = 'CERTIFICATE_GRID_COLUMN_INFO_SUCCESS';
export const CERTIFICATE_GRID_COLUMN_INFO_ERROR = 'CERTIFICATE_GRID_COLUMN_INFO_ERROR';
export const GET_CERTIFICATE_DETAIL_GRID = 'CERTIFICATE_DETAIL_GRID';
export const GET_CERTIFICATE_DETAIL_GRID_SUCCESS = 'CERTIFICATE_DETAIL_GRID_SUCCESS';
export const GET_CERTIFICATE_DETAIL_GRID_ERROR = 'CERTIFICATE_DETAIL_GRID_ERROR';

// Short Detail (for preview drawer)
export const GET_CERTIFICATE_SHORT_DETAIL = 'GET_CERTIFICATE_SHORT_DETAIL';
export const GET_CERTIFICATE_SHORT_DETAIL_SUCCESS = 'GET_CERTIFICATE_SHORT_DETAIL_SUCCESS';
export const GET_CERTIFICATE_SHORT_DETAIL_ERROR = 'GET_CERTIFICATE_SHORT_DETAIL_ERROR';

// Full Detail (optional additional data)
export const GET_CERTIFICATE_FULL_DETAIL = 'GET_CERTIFICATE_FULL_DETAIL';
export const GET_CERTIFICATE_FULL_DETAIL_SUCCESS = 'GET_CERTIFICATE_FULL_DETAIL_SUCCESS';
export const GET_CERTIFICATE_FULL_DETAIL_ERROR = 'GET_CERTIFICATE_FULL_DETAIL_ERROR';

// Associations (Products linked to Certificate)
export const GET_PRODUCTS_FOR_CERTIFICATES = 'GET_PRODUCTS_FOR_CERTIFICATES';
export const GET_PRODUCTS_FOR_CERTIFICATES_SUCCESS = 'GET_PRODUCTS_FOR_CERTIFICATES_SUCCESS';
export const GET_PRODUCTS_FOR_CERTIFICATES_ERROR = 'GET_PRODUCTS_FOR_CERTIFICATES_ERROR';

export const GET_COLUMNS_CERTIFICATES_FOR_MEMBER_SUCCESS =
  'GET_COLUMNS_CERTIFICATES_FOR_MEMBER_SUCCESS';

// Member selection
export const SAVE_ID_MEMBER = 'SAVE_ID_MEMBER';

// Edit / Update
export const UPDATE_CERTIFICATE_TYPE_PANE = 'UPDATE_CERTIFICATE_TYPE_PANE';
export const UPDATE_CERTIFICATE_TYPE_PANE_SUCCESS =
  'UPDATE_CERTIFICATE_TYPE_PANE_SUCCESS';
export const UPDATE_CERTIFICATE_TYPE_PANE_ERROR =
  'UPDATE_CERTIFICATE_TYPE_PANE_ERROR';

// Toggle New Certificate Pane UI
export const TOGGLE_CERTIFICATE_NEW = 'TOGGLE_CERTIFICATE_NEW';
export const CACHE_CERTIFICATE_FROM_DATE = 'CACHE_CERTIFICATE_FROM_DATE';
